// @ts-nocheck
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import styled, { css } from "styled-components";

export const Title = styled(Typography)`
    text-align: center;
    width: 100%;
    text-indent: ${pxToRem(44)};
    margin-block-end: 0;
`;

export const SignaturePadCard = styled.div`
    width: 100%;
    border-top: 24px solid ${getColor("common.borderColored")};
    height: 100%;
    padding: 1rem;
    display: flex;
    height: 18rem;
    border-radius: ${pxToRem(12)};
    box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px;
    background-color: ${getColor("common.background")};
`;

export const ButtonRow = styled.div`
    display: flex;
    justify-content: space-around;
    width: 100%;
    row-gap: 1rem;
`;

export const EmailMeContainer = styled.div`
    width: 100%;
    min-height: 4.875rem;
    display: flex;
    align-self: flex-start;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    row-gap: 1rem;
    padding-inline: 0.5rem;
`;

// needed to not duplicate styles for input element. Using !important on styles that are being overridden by error state
export const generateInputStyles = (isEmailInput: boolean) => {
    return {
        cssOverrides: {
            formField: css`
                width: unset;
                padding: 0;
                margin-right: 1rem;
            `,
            inputSelect: css`
                &:disabled {
                    color: inherit;
                    background-color: ${getColor("common.background")};
                }
                width: ${isEmailInput ? "20rem" : "inherit"};
                border-radius: 0.5rem;
                padding-inline: 1rem;
                outline: transparent solid 2px;
                outline-offset: 2px;
                border-width: 1px;
                border-style: solid;
                font-size: 1rem;
                height: 2.25rem;
                position: relative;
                transition: all 0.2s ease;
                appearance: none;
                &:focus {
                    border-radius: 0.5rem;
                    padding: initial;
                    padding-inline: 1rem;
                }
                &:focus-visible {
                    z-index: 1;
                    border-color: ${getColor("common.customFocus")};
                    box-shadow: ${getColor("common.customFocus")} 0px 0px 0px 1px;
                    border-radius: 0.5rem;
                    padding: initial;
                    padding: 0 ${pxToRem(16)} 0 ${pxToRem(16)};
                }
            `,
        },
    };
};
